import { Component, Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-autocomplite',
  templateUrl: './autocomplite.component.html',
  styleUrls: ['./autocomplite.component.css']
})
export class AutocompliteComponent {
  @Input() public units = new EventEmitter();
  @Input() public parentShowResoults = new EventEmitter();
  @Output() public choisen = new EventEmitter();
  @Output() public showSearchResults = new EventEmitter();


  searchTerm: any;
  showResoults: boolean = false;

  ngOnInit(): void {
    console.log('AUTOCOMPLITE')
  }

  showResultsF() {
    this.showResoults = true;
    this.showSearchResults.emit(true);
  }
  hideResultsF() {
    this.showResoults = false;
    this.showSearchResults.emit(true);
  }
  sendNumber(number) {
    this.searchTerm = number;
    this.choisen.emit(number);
    this.showResoults = false;
  }
}
